export default __webpack_public_path__ + "static/media/network-3.5d508ba8.png";